import { Box, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { USER_ROLES, saveGlobalToggleState } from '@pwc/pwc-deals-web-common';
import { ExclamationIcon } from 'common/icons/ExclamationIcon';
import { setUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';

export const GlobalToggleNotAvailable = () => {
  const dispatch = useDispatch();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          '& svg': {
            width: '72px',
            mb: '1.688rem',
          },
        }}
      >
        <ExclamationIcon />
        <Box
          sx={{
            fontSize: '1.875rem',
            fontWeight: 700,
            mb: '0.75rem',
          }}
        >
          Unable to view this page
        </Box>
        <Box
          sx={{
            fontSize: '1rem',
            mb: '1.5rem',
          }}
        >
          Sorry, you can&apos;t view this page when you are
          &apos;Viewing&nbsp;tab&nbsp;as&nbsp;client&apos;.
        </Box>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => {
            dispatch(setUserRole(USER_ROLES.PWC_USER));
            saveGlobalToggleState(USER_ROLES.PWC_USER);
          }}
        >
          Switch to PwC view
        </Button>
      </Box>
    </Box>
  );
};
